export default "__VITE_ASSET__DRtz0sRe__"